import { searchUsers } from '@/entities/User';
import { mapEntityUserToAdminUser } from '../model';
import type { AdminUser } from '../model';
import type { SearchParams, Pagination } from '@/shared/lib';

export async function searchAdminUsers(
  searchUrl: string,
  searchParams: SearchParams
): Promise<{ data: AdminUser[]; metadata: Pagination }> {
  const result = await searchUsers(searchUrl, searchParams);

  return {
    data: result.data.map(mapEntityUserToAdminUser),
    metadata: result.metadata,
  };
}
